module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOAQMAAAAlhr+SAAAAA1BMVEUiMv9cwRSoAAAAC0lEQVQI12MgGgAAACoAAXbMpCAAAAAASUVORK5CYII="